module.exports = __webpack_public_path__ + "static/img/pikto_domek.ab1ecfe8.svg";